import { Pipe, PipeTransform } from '@angular/core';
/*
 * Returns initials of an object with a firstName
 * and lastName.
 *  *
 * Usage:
 *   user = {"firstName": "foo", "lastName": "bar"}
 * Example:
 *   {{ user | initials }}
 *   formats to: 1024
*/
@Pipe({name: 'initials'})
export class InitialsPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return '';
    }

    let result = '';
    let val = value;

    if (value.name) {
      val = value.name;
    }

    if (typeof val === 'string') {
      const split = val.split(' ');
      result += split[0][0].toUpperCase();
      if (split[1]) {
        result += split[1][0].toUpperCase();
      }
      return result;
    }

    if (val.firstName) {
      result += val.firstName[0].toUpperCase();
    }
    if (val.lastName) {
      result += val.lastName[0].toUpperCase();
    }

    return result;
  }
}
